module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_c('a', {
    attrs: {
      "href": "#/004toc#introduction"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There comes a point in every life when clouds gather, the path grows dark, and you find yourself surrounded by devilish ghouls, dashing vampires, and an unsettling number of decapitated zombies. Never fear—this little book will prepare you for whatever horrors lurk just around the corner. Simply find the entry that corresponds to your birthday and learn what chilling fate the stars have planned for you. Of course, it also doesn’t hurt to keep a wooden stake handy …")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64b3f36a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003introduction.vue
// module id = 63
// module chunks = 0